import React, { memo, useMemo } from 'react';

import Icon from '@components/shared/Icon/Icon';
import Images from '@themes/images';
import theme from '@themes/theme';

type Props = {
  icon?: keyof typeof Images | string | null;
  color?: string | null;
  variant?: React.ComponentProps<typeof Icon>['variant'];
};

const PROJECT_COLOR_MAP: Record<string, keyof typeof theme.colors> = {
  red: 'alertRed',
  orange: 'orange',
  yellow: 'yellowVivid',
  secondaryGreen: 'greenSecondary',
  green: 'greenDark',
  blue: 'blue',
  purple: 'purple',
  lightMagenta: 'magentaLight',
  magenta: 'magentaDark',
};

export const ProjectAvatar: React.FC<Props> = memo(function ProjectAvatar({
  icon,
  color,
  variant = 'xxs',
}) {
  const iconName = useMemo(
    () =>
      icon && icon in Images ? (icon as keyof typeof Images) : 'ProjectIcon',
    [icon]
  );

  const iconColor = useMemo(
    () =>
      color
        ? theme.colors[PROJECT_COLOR_MAP[color] ?? PROJECT_COLOR_MAP.red]
        : undefined,
    [color]
  );

  return (
    <Icon
      name={iconName}
      variant={variant}
      style={{
        color: iconColor,
      }}
    />
  );
});
